import { IDialogAction } from './IDialogAction';
import { DialogState } from '../../dialog-feed/models/DialogState';

export const COMMENT_ADDED = 'COMMENT_ADDED';

export class CommentAddedAction implements IDialogAction {
    public readonly type = COMMENT_ADDED;
    public constructor(public payload: any) {}
    public reducer(state: DialogState): DialogState {
        if(this.payload.parentIds.length > 1) {
            state.feed.messages.forEach(m => {
                m.comments.forEach(c => {
                    if(+c.id !== this.payload.parentIds[1]) {
                        return;
                    }
                    console.log(c.comments, +this.payload.comment.i);
                    if(c.comments.filter(ic => { return ic.id === +this.payload.comment.i }).length) {
                        return;
                    }
                    c.comments.push({
                        id: +this.payload.comment.i,
                        text: this.payload.comment.t,
                        author: {
                            id: '',
                            externalId: this.payload.comment.l,
                            name: this.payload.comment.a,
                            profileUrl: `/_layouts/15/me.aspx?p=${this.payload.comment.l}`,
                            profilePhotoUrl: `/_layouts/15/userphoto.aspx?size=M&accountname=i%3A0%23.f%7Cmembership%7C${encodeURIComponent(this.payload.comment.l)}`
                        },
                        posted: new Date(this.payload.comment.p + '.000Z'),
                        liked: this.payload.comment.icl,
                        likes: [],
                        comments: []
                    });
                });
            });
        }
        else if(this.payload.parentIds.length > 0) {
            state.feed.messages.forEach(m => {
                if(+m.id !== this.payload.parentIds[0]) {
                    return;
                }
                console.log(m.comments, +this.payload.comment.i);
                if(m.comments.filter(ic => { return ic.id === +this.payload.comment.i }).length) {
                    return;
                }
                m.comments.push({
                    id: +this.payload.comment.i,
                    text: this.payload.comment.t,
                    author: {
                        id: '',
                        externalId: this.payload.comment.l,
                        name: this.payload.comment.a,
                        profileUrl: `/_layouts/15/me.aspx?p=${this.payload.comment.l}`,
                        profilePhotoUrl: `/_layouts/15/userphoto.aspx?size=M&accountname=i%3A0%23.f%7Cmembership%7C${encodeURIComponent(this.payload.comment.l)}`
                    },
                    posted: new Date(this.payload.comment.p + '.000Z'),
                    liked: this.payload.comment.icl,
                    likes: [],
                    comments: []
                });
            });
        }
        return state;
    }
}

export const CommentAddedActionTypeMapping = {
    [COMMENT_ADDED]: CommentAddedAction
};